import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";
import { colors } from "src/colors/colors";
import ContainerMain from "src/commonStyles/container/containerMain/containerMain";
import FooterHome from "src/components/homePage/footer/footerHome";
import HeaderHome from "src/components/homePage/header/headerHome";
import { convertTotalAmountToVND } from '../../utils/convert/totalAmount';
convertTotalAmountToVND
const useStyles = makeStyles((theme) => {
  return {
    containerContent: {
      paddingTop: "16px",
      [theme.breakpoints.down("md")]: {
        background: colors.white,
        padding: "16px 8px 16px 8px",
        borderRadius: "8px",
        marginBottom: "50px",
      },
    },
  };
});
const MainLayout = ({ children }) => {
  const [header, setHeader] = useState(document?.getElementById("app-header"));
  const classes = useStyles();
  useEffect(() => {
    setHeader(document?.getElementById("app-header"));
  }, []);
  const pdt = header?.clientHeight;
  return (
    <div style={{ background: "#F5F5F5" }} className="page">
      <HeaderHome />
      <div className="" style={{ paddingTop: `${pdt + 8}px` }}>
        <ContainerMain>
          <div className={classes.containerContent}>{children}</div>
        </ContainerMain>
      </div>
      <FooterHome />
    </div>
  );
};

export default MainLayout;
